import { combineReducers } from 'redux';
import { form, modal } from '@spring/smeargle/reducers';

const combined = combineReducers({
  form,
  modal,
});

let actions = [];

const rootReducer = (state, action) => {
  if (actions.length > 100) {
    actions.shift();
  }

  actions.push(action);

  return combined(state, action);
};

const getActions = () => actions;

export { getActions };
export default rootReducer;
